<template>
	<div class="headerAvatar">
		<div class="head_notice" @click="toNoticeList">
			<a-badge :count="getMsgCount" :overflowCount="99" v-if="getMsgCount > 0">
				<a-icon type="bell" style="fontSize:19px;" theme="filled"/>
			</a-badge>

			<a-icon v-else type="bell" style="fontSize:19px;" theme="filled"/>
			<!-- <a-buttom>论坛</a-buttom> -->
		</div>
		<div style="cursor: pointer;display:flex;align-items:center;margin-right: 25px;">
			<a :href="BBSUrl">
				<a-button style="">论坛</a-button>
				<!-- <img @click="goForBBS" style="width: 20px; margin: -5px 10px 0;" src="../../../static/img/bbs.png"> -->
			</a>
		</div>
		<a-dropdown>
			<div style="cursor: pointer;display:flex;align-items:center;">
				<a-avatar class="avatar" size="small" shape="circle"
						  :src="avatar"/>
				<span class="curr-user">{{user.realname}}</span>
			</div>
			<a-menu style="width: 120px" slot="overlay">
				<a-menu-item @click="openProfile">
					<a-icon type="user"/>
					<span>个人中心</span>
				</a-menu-item>
				<a-menu-item @click="updatePassword">
					<a-icon type="key"/>
					<span>密码修改</span>
				</a-menu-item>
				<a-menu-divider></a-menu-divider>
				<a-menu-item @click="handleSettingClick">
					<a-icon type="setting"/>
					<span>系统定制</span>
				</a-menu-item>
				<a-menu-divider></a-menu-divider>
				<a-menu-item @click="logout">
					<a-icon type="logout"/>
					<span>退出登录</span>
				</a-menu-item>
			</a-menu>
		</a-dropdown>
		<update-password
			@success="handleUpdate"
			@cancel="handleCancelUpdate"
			:user="user"
			:updatePasswordModelVisible="updatePasswordModelVisible">
		</update-password>
	</div>
</template>

<script>
	import {mapMutations, mapState} from 'vuex'
	import UpdatePassword from '../personal/UpdatePassword'
	import store from '../../store'

	export default {
		name: 'HeaderAvatar',
		components: {UpdatePassword},
		data () {
			return {
				updatePasswordModelVisible: false,
				myMsgCount: 0,
				BBSUrl: '',
			}
		},
		computed: {
			...mapState({
				settingBar: state => state.setting.settingBar.opened,
				user: state => state.account.user,
				domainPath: state => state.setting.domainPath
			}),
			avatar () {
				return this.domainPath + this.user.avatar
			},
			getMsgCount(){
				return this.$store.state.msgCount
			},
		},
		mounted () {

			this.$get('config/getValueByKey', {key: 'BBSUrl'}).then((r) => {
				this.BBSUrl = r.data.data
			})
			this.$get('officialMsg/myMsgCount').then((r) => {
				this.$store.commit('update', ['msgCount', r.data])
			})

		},
		methods: {
			goForBBS () {
				setCookie('token', this.$store.state.account.token)
			},
			toNoticeList () {
				this.$router.push({
					path: '/noticeList'
				})
			},
			handleSettingClick () {
				this.setSettingBar(!this.settingBar)
			},
			openProfile () {
				this.$router.push('/profile')
			},
			updatePassword () {
				this.updatePasswordModelVisible = true
			},
			handleCancelUpdate () {
				this.updatePasswordModelVisible = false
			},
			handleUpdate () {
				this.updatePasswordModelVisible = false
				this.$message.success('更新密码成功，请重新登录系统')
				setTimeout(() => {
					this.logout()
				}, 1500)
			},
			logout () {
				this.$get(`logout/${this.user.id}`).then(() => {
					return new Promise((resolve, reject) => {
						this.$db.clear()
						this.$socketApi.websocketClose()
						location.reload()
					})
				}).catch((e) => {
					// this.$message.error('退出系统失败')
					console.log(e)
					location.reload()
				})
			},
			...mapMutations({setSettingBar: 'setting/setSettingBar'})
		}
	}
</script>

<style lang="less" scoped>
	.ant-avatar-sm {
		width: 30px;
		height: 30px;
	}

	.avatar {
		margin: 10px 4px 10px 0;
		color: #1890ff;
		background: hsla(0, 0%, 100%, .85);
		vertical-align: middle;
	}

	.curr-user {
		font-weight: 600;
		// margin-left: 6px
	}

	.headerAvatar {
		display: flex;

		.head_notice {
			width: 60px;
			padding: 5px 20px 0 0;
			position: relative;

			span {
				width: 7px;
				height: 7px;
				border-radius: 50%;
				background-color: red;
				display: block;
				position: absolute;
				top: 21px;
				left: 16px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/common/HeaderAvatar.vue